import { SignUpMutationVariables } from '@sketch/gql-types'

export type Values = {
  name: string
  password: string
  email: string
  professionalRole?: SignUpMutationVariables['input']['professionalRole']
  'terms-of-service': boolean
  'privacy-policy': boolean
  'marketing-consent': boolean
}

export const SIGN_UP_INITIAL_VALUES: Values = {
  name: '',
  password: '',
  email: '',
  professionalRole: undefined,
  'terms-of-service': false,
  'privacy-policy': false,
  'marketing-consent': false,
}

export const TERMS_OF_SERVICE_PRIVACY_POLICY_ERROR =
  'You need to agree to the Terms of Service and Privacy Policy to continue'
